// generated by genversion
export var version = '5.0.4';


//////////////////
// WEBPACK FOOTER
// ./~/amazon-cognito-identity-js/es/Platform/version.js
// module id = 530
// module chunks = 0